import PropTypes from "prop-types";
import React from "react";
import MyAchievementsButtons from "../../views/Performance/MyAchievementsButtons";
import FullPageLayout from "../../components/FullPageLayout";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { push } from "connected-react-router";
import { withTranslation } from "react-i18next";
import { Route } from "react-router-dom";
import {
  performanceAchievements,
  performanceTranscript,
  performanceLeaderboard
} from "../../routes/LearningCenterRoutes";
import MyAchievements from "../../views/Performance/index";
import TranscriptReport from "../../views/Performance/TranscriptReport";
import LearningCenterLeaderboard from "./LearningCenterLeaderboard";
import {
  emailTranscriptReportURL,
  printTranscriptReportURL
} from "../../../src/routes/AdminRoutes";

const LearningCenterPerformance = props => {
  const { pathname, user, push, t } = props;

  const localTime = `local_time=${new Date().getTimezoneOffset() / -60}`;
  let emailReportUrl = emailTranscriptReportURL;
  let printReportUrl = printTranscriptReportURL;

  printReportUrl += localTime;
  emailReportUrl += localTime;
  if (props.tableFilter && props.tableFilter !== "Timeframe") {
    const timeRangeProp = `time_range=${props.tableFilter}`;
    printReportUrl += timeRangeProp;
    emailReportUrl += timeRangeProp;
  }
  const transcriptReportView = pathname === performanceTranscript;
  const headerButtons = (pathname === performanceTranscript ||
    pathname === performanceAchievements) && (
    <MyAchievementsButtons
      printButtonText={t("learningCenterPerformance.printButton")}
      emailButtonText={t("learningCenterPerformance.emailButton")}
      trainingObjectId={"transcript"}
      emailModalType="report"
      printUrl={printReportUrl}
      emailUrl={emailReportUrl}
    />
  );

  const handleCloseTranscriptReport = () => {
    push(performanceAchievements);
  };

  return (
    <FullPageLayout
      headerActions={headerButtons}
      title={
        transcriptReportView
          ? t("learningCenterPerformance.transcriptTitle", {
              firstName: user.firstName,
              lastName: user.lastName
            })
          : pathname === performanceLeaderboard
          ? t("learningCenterPerformance.awardsLeaderboard")
          : t("learningCenterPerformance.achievements")
      }
      onCloseClick={transcriptReportView ? handleCloseTranscriptReport : null}
    >
      <Route exact path={performanceAchievements} component={MyAchievements} />
      <Route exact path={performanceTranscript} component={TranscriptReport} />
      <Route
        exact
        path={performanceLeaderboard}
        render={() => <LearningCenterLeaderboard user={user} />}
      />
    </FullPageLayout>
  );
};

const mapStateToProps = state => ({
  user: state.userState.user,
  pathname: state.router.location.pathname,
  tableFilter: state.transcriptReportState.tableFilter
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ push }, dispatch);
}

const TranslatedLearningCenterPerformance = withTranslation()(
  LearningCenterPerformance
);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TranslatedLearningCenterPerformance);

LearningCenterPerformance.propTypes = {
  match: PropTypes.any
};
